// The Account page's Usage tab (laravel App\Usage): month by month what the invoices charge for, counted by the
// invoicing code itself, and a month per guard.
import { monthLabel } from './invoices';

export const NO_USAGE = 'No usage yet.';

// "November 2026" or "November 2026 (so far)" for the running month
export function usageMonthLabel(row) {
	if (!row) {
		return '';
	}
	return monthLabel(row.month) + (row.so_far ? ' (so far)' : '');
}

// Where the month's duty starts are charged: its invoice(s), or which invoice will take them
export function invoiceText(row) {
	if (!row) {
		return '';
	}
	if (row.so_far) {
		return 'Invoiced after the month ends';
	}
	const parts = [];
	if (row.invoices && row.invoices.length > 0) {
		parts.push(row.invoices.join(', '));
	}
	if (row.pending === 'to_be_invoiced') {
		parts.push(parts.length ? 'the rest on the next invoice' : 'On the next invoice');
	} else if (row.pending === 'carried') {
		parts.push(parts.length ? 'the rest carried over to the next invoice' : 'Carried over to the next invoice');
	}
	return parts.length ? parts.join('; ') : '–';
}

export const PRICE_VARIES = 'Varies, see month';

// The month's price per duty start: the price when it has one, else "Varies, see month" (the month popup has a row per price)
export function priceText(row) {
	const prices = row && Array.isArray(row.prices) ? row.prices : [];
	if (prices.length === 0) {
		return '–';
	}
	return prices.length === 1 ? usd(prices[0]) : PRICE_VARIES;
}

export function usd(amount) {
	return 'USD ' + (amount === null || amount === undefined || amount === '' ? '0.00' : amount);
}

// The amounts are the invoice lines before VAT: said only when there is VAT
export function vatNote(vatRate) {
	const rate = Number(vatRate);
	if (!rate || isNaN(rate)) {
		return '';
	}
	return 'Amounts are before VAT (' + (Number.isInteger(rate) ? rate : rate.toFixed(2)) + '%).';
}

export function hasUsage(months) {
	return Array.isArray(months) && months.some((row) => row.duty_starts > 0);
}
